module.exports = __webpack_public_path__ + "static/img/成五-孫震宇.ad91664.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/成五-孫震宇.jpg
// module id = JyHk
// module chunks = 1